import React from 'react'
import {
  Container,
  Row,
  Col
} from 'reactstrap'
import RenderDataModal from '../RenderViewModal/RenderViewModal'
import useAsyncService from '../../../../hooks/useAsyncService'
import { LoadIndicator } from 'devextreme-react'
import ICSErrorCard from '../../../../components/ICSErrorCard/ICSErrorCard'
import { quickView } from '../../../../services/endpoints/quickView'

export interface TextDialogProps {
  onClose: () => void
  uploadFileVersionId: number
  fileName: string
}
const TextDialog: React.FC<TextDialogProps> = ({ onClose, uploadFileVersionId, fileName }) => {
  const {serviceValue, serviceLoading, serviceError} = useAsyncService({
    serviceCall: quickView,
    initialArgs: uploadFileVersionId,
    validateServiceResults(res) {
        return typeof res === 'string'
    }
  })

  const getBody = () => {    
    if(serviceLoading) {
      return (
           <LoadIndicator />
      )
    } else if(serviceError) {
      return(
          <ICSErrorCard
            code={'error'}
            message={serviceError}
            fields={[]}
          />
      )
    } else if(!serviceValue) {
      return <>Empty</>
    } else {
      return (
        <pre id='extractionNotesText'>
          {serviceValue}
        </pre>
      )
    }
  }

  return (
    <RenderDataModal onClose={onClose} title={`Text Viewer for ${fileName}`}>
      <Container className="notes-container">
        <Row className="notes-row">
          <Col>
            {getBody()}
          </Col>
        </Row>
      </Container>
    </RenderDataModal>
  )
}

export default TextDialog
